import { c as _c } from "react/compiler-runtime";
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterSplitTestInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useCreateSplitTest = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = newsletterId => fetcher(`${NEWSLETTERS_API}/${newsletterId}/split-test`);
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isFetching || $[4] !== t1) {
    t2 = {
      createSplitTest: t1,
      isFetching
    };
    $[3] = isFetching;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};